import React from 'react';
import useInactivity from '../../../hooks/useInactivity';
import { useNavigate, useLocation } from 'react-router-dom';
import { clearCache } from '../../../funciones/apiCache';
import { cn } from '../../../lib/utils';

function CuerpoPrincipal({ children, setAutenticado, ...rest }) {
  const navigate = useNavigate();
  const location = useLocation();

  const publicRoutes = ['/login', '/cambiarPassword'];
  const isPublicRoute = publicRoutes.some(route =>
    location.pathname === route || location.pathname.startsWith(route + '/')
  );

  const handleInactivity = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("lastActivity");
    localStorage.removeItem("numActivo");
    clearCache();
    setAutenticado(false);
    navigate("/login", { replace: true });
  };

  const deberiaUsarInactividad = rest.autenticado && !isPublicRoute;
  useInactivity(handleInactivity, deberiaUsarInactividad ? 60 * 60 * 1000 : null);

  if (!rest.autenticado) return <>{children}</>;

  const paddingTop = rest.isMobile && !rest.isOpen
    ? 'pt-[120px]'
    : rest.isOpen
      ? 'pt-[350px]'
      : 'pt-[4%]';

  const paddingLeft = rest.isMobile
    ? 'pl-[10px]'
    : !rest.showSidebar
      ? 'pl-[120px]'
      : rest.invisible
        ? 'pl-[200px]'
        : 'pl-[270px]';

  const paddingRight = !rest.showSidebar
    ? 'pr-[20px]'
    : rest.invisible
      ? ''
      : 'pr-0';

  const width = rest.isMobile || !rest.showSidebar ? 'w-full' : 'w-[99%]';
  const height = rest.invisible ? 'h-[92.5vh]' : 'h-auto';
  const bg = rest.invisible ? 'bg-[#DBE7F3]' : 'bg-transparent';

  return (
    <div
      className={cn(
        'pb-[1%]',
        paddingTop,
        paddingLeft,
        paddingRight,
        width,
        height,
        bg,
        rest.invisible && 'max-[1368px]:pl-[25%] max-[1368px]:pr-[20%]'
      )}
    >
      {children}
    </div>
  );
}

export default CuerpoPrincipal;
